import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import Navigation from '@/components/Navigation';
import { Heart } from 'lucide-react';
import { copy } from '@/copy';

const AboutPage = () => {
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-[#F5F5F5]">
      <Navigation />
      
      <main className="max-w-2xl mx-auto px-4 py-12 sm:py-16">
        <article className="animate-fade-in">
          {/* Page Title */}
          <header className="text-center mb-12">
            <h1 className="font-serif text-3xl sm:text-4xl text-[#1D2D44] mb-3">
              About Our Love <Heart className="inline-block w-6 h-6 sm:w-7 sm:h-7 text-[#C9A84C] mx-1" strokeWidth={1.5} /> Connection
            </h1>
          </header>

          {/* Content */}
          <div className="prose prose-lg max-w-none space-y-6 text-[#1D2D44] leading-relaxed">
            <p>
              {copy.about.content.intro}
            </p>

            <p>
              {copy.about.content.problem}
            </p>

            <p className="font-medium text-[#1D2D44]">
              {copy.about.content.different}
            </p>

            <p>
              {copy.about.content.solution}
            </p>

            <p>
              {copy.about.content.audience}
            </p>

            <p>
              {copy.about.content.values}
            </p>

            <p>
              {copy.about.content.closing}
            </p>

            <p className="font-serif text-xl text-[#1D2D44] italic pt-4">
              {copy.about.content.tagline}
            </p>
          </div>

          {/* How It Works Section */}
          <div className="mt-16 pt-12 border-t border-[#E5E5E5]">
            <h2 className="font-serif text-2xl sm:text-3xl text-[#1D2D44] mb-8">
              {copy.about.howItWorks.title}
            </h2>
            
            <div className="space-y-6 text-[#1D2D44] leading-relaxed">
              <p>
                Our Love <span className="text-[#C9A84C]">&#9829;</span> Connection{copy.about.howItWorks.intro.substring(copy.about.howItWorks.intro.indexOf('Connection') + 10)}
              </p>

              <p>
                {copy.about.howItWorks.realPeople}
              </p>

              <p>
                {copy.about.howItWorks.profiles}
              </p>

              <p className="font-medium text-[#1D2D44]">
                {copy.about.howItWorks.different}
              </p>

              <p>
                {copy.about.howItWorks.reflection}
              </p>

              <p>
                {copy.about.howItWorks.introduction}
              </p>

              <p>
                {copy.about.howItWorks.structure}
              </p>

              <p>
                {copy.about.howItWorks.approach}
              </p>

              <p className="text-[#424E59] italic">
                {copy.about.howItWorks.notForYou}
              </p>

              <p className="font-medium text-[#1D2D44]">
                {copy.about.howItWorks.forYou}
              </p>
            </div>
          </div>
        </article>
      </main>

      {/* Simple Footer */}
      <footer className="py-8 px-4 border-t border-[#E5E5E5]">
        <div className="max-w-2xl mx-auto text-center">
          <p className="text-[#424E59] text-sm">
            {copy.brand.copyright(new Date().getFullYear())}
          </p>
        </div>
      </footer>
    </div>
  );
};

export default AboutPage;
